import React from 'react';
import CardButton from '../CardButton/CardButton';
import './TaskSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import { view_all_tasks} from '../../../../../cosmosTracking/cosmosEvents'
import { resolveTutorHomeAsset, globalText } from '../tutorHomeConfig';
function TaskSlide(props) {
	const { data, config = {} } = props;
	return (
		<div className="slideCard slideCardTask">
			<div className="cardBody" style={config.images?.card_background ? {'--tutor-home-card-background': `url("${resolveTutorHomeAsset(config.images.card_background)}")`} : undefined}>
				<img src={resolveTutorHomeAsset(config.images?.background_overlay || 'https://cdn-wl-assets.classplus.co/production/379965/ebfc73ce-c684-43c8-afd9-d21279120362.png')} className='overlay-image' />
				
				<img className="task-top-img" src={resolveTutorHomeAsset(config.images?.header_artwork || 'https://cdn-wl-assets.classplus.co/production/379965/2c21a99d-4f9e-44cb-b9b3-9dd11f70ecce.jpeg')} alt="task img"/>
				
				<div className="taskData">
					<img src={resolveTutorHomeAsset(config.images?.gift_artwork || 'https://cdn-wl-assets.classplus.co/production/379965/eaaa71aa-eaa1-414b-b284-18bfd0fb473b.png')} alt="box" width='100%' height='100%' />
				</div>
				<CardButton text={globalText.view_tasks_label || 'View All Tasks'}
							eventCallback={() => {
								cosmosTrackService(view_all_tasks);
							}}
							className={'btn-action'}
							deeplink={data?.deeplink}
				/>
			</div>
		</div>
	);
}

export default TaskSlide;
